import { FGEmptyState } from '@fg/design-system';
import GQLoader from 'components/GQLoader/GQLoader';

type Props = {
    isLoading: boolean;
    loadFailed: boolean;
    isEmpty: boolean;
    failedMessage: string;
};

const FeedEmptyState = ({ isLoading, loadFailed, isEmpty, failedMessage }: Props) => {
    if (!isEmpty) return null;
    if (isLoading) {
        return (
            <div style={{ paddingBlock: 16 }}>
                <GQLoader />
            </div>
        );
    }
    return <FGEmptyState message={loadFailed ? failedMessage : 'No results found'} />;
};

export default FeedEmptyState;
